export default "__VITE_ASSET__O5JyTGTN__"